import { IQuestionsGroupProps } from 'app/components/questions/base'
import { QuestionsGroupMediator } from 'app/components/questions/mediator'
import { Container } from 'app/containers/Container'

// tslint:disable-next-line:no-empty-interface
interface IQuestionsGroupContainerProps extends IQuestionsGroupProps {
  //for later updates
}

abstract class QuestionsGroupContainer<P extends IQuestionsGroupContainerProps, S> extends Container<P, S> {
  abstract state: S

  getValueForQuestion(questionName: string) {
    return QuestionsGroupMediator.getValueForQuestion(questionName)
  }
}

export {
  QuestionsGroupContainer,
  IQuestionsGroupContainerProps
}



// WEBPACK FOOTER //
// ./src/app/containers/PipelineSection/QuestionGroupContainer.tsx